import React from "react";

export default function DeleteConfirmationModal({
  open,
  name,
  title = "Delete User?",
  subtitle = "Confirm user deletion",
  message,
  detail = "Please verify the user's details before proceeding.",
  error = "",
  extraContent = null,
  deleting = false,
  confirmLabel = "Delete User",
  onCancel,
  onConfirm
}) {
  if (!open) return null;

  const confirmationMessage = message ||
    `Are you sure you want to delete ${name || "this user"}? This will remove their account, and they may lose access to EnrollEase. This action cannot be undone.`;

  return (
    <div
      role="presentation"
      onMouseDown={event => {
        if (event.target === event.currentTarget && !deleting) onCancel();
      }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        background: "rgba(15, 23, 42, 0.55)"
      }}
    >
      <section
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="delete-confirmation-title"
        aria-describedby="delete-confirmation-message"
        style={{
          width: "100%",
          maxWidth: 460,
          padding: 26,
          borderRadius: 12,
          background: "#fff",
          boxShadow: "0 18px 48px rgba(0,0,0,0.24)"
        }}
      >
        <h2 id="delete-confirmation-title" style={{ margin: "0 0 6px", color: "#8a1c1c", fontSize: 21 }}>
          {title}
        </h2>
        <div style={{ marginBottom: 14, color: "#475569", fontWeight: 700 }}>
          {subtitle}
        </div>
        <p id="delete-confirmation-message" style={{ margin: "0 0 10px", color: "#334155", lineHeight: 1.55 }}>
          {confirmationMessage}
        </p>
        {detail && <p style={{ margin: "0 0 18px", color: "#64748b", fontSize: 14, lineHeight: 1.5 }}>{detail}</p>}
        {error && <div role="alert" style={{ marginBottom: 16, color: "#8a1c1c" }}>{error}</div>}
        {extraContent}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button
            type="button"
            onClick={onCancel}
            disabled={deleting}
            style={{ padding: "9px 16px", border: "1px solid #cbd5e1", borderRadius: 8, background: "#fff", color: "#334155", fontWeight: 600, cursor: deleting ? "not-allowed" : "pointer" }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={deleting}
            style={{ padding: "9px 16px", border: "none", borderRadius: 8, background: "#b42318", color: "#fff", fontWeight: 700, cursor: deleting ? "not-allowed" : "pointer" }}
          >
            {deleting ? "Deleting..." : confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );
}
